import React from "react";
// https://reactjs.org/docs/error-boundaries.html

const defaultNLS = {
  error: "Es tut uns Leid, aber in diesem Modul ist ein Fehler aufgetreten.",
};
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.nls = props.nls || defaultNLS;
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error(error);
    console.error(errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // render Error UI on Error
      return (
        <>{this.props.ErrorUI || this.props.ErrorText || this.nls.error}</>
      );
    }
    // otherwise just render the children
    return this.props.children;
  }
}

export default ErrorBoundary;
